import axios from 'axios';
import sesionService from '@/services/SesionService';

export default {
	async getAllDocumentForList(params) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(
					`/document/list${
						params ? `?${new URLSearchParams(params).toString()}` : ''
					}`,
					HEADER
				);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getAllDocument(params) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(
					`/document/all${
						params ? `?${new URLSearchParams(params).toString()}` : ''
					}`,
					HEADER
				);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getAllForSelect(query) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(`/document/for-select?query=${query}`, HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getDocumentById({ docId, entity, entityId }) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(`/document/${docId}${entity && entityId ? `/${entity}/${entityId}` : '' }`, HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async saveDocumentElement(documentElement) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			let { title, category, subcategory, documentData, isEditable, isHeritable, isPreLoaded } =
				documentElement;

			try {
				let res = await axios.post(
					'/document',
					{
						title,
						category,
						subcategory,
						documentData,
						isEditable,
						isHeritable,
						isPreLoaded
					},
					HEADER
				);

				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async updateDocumentElement(documentElement) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			let {
				title,
				category,
				subcategory,
				documentData,
				_id,
				notifications,
				isEditable,
				isHeritable,
				isPreLoaded
			} = documentElement;

			try {
				let res = await axios.put(
					`/document/${_id}`,
					{
						title,
						category,
						subcategory,
						documentData,
						notifications,
						isEditable,
						isHeritable,
						isPreLoaded
					},
					HEADER
				);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async printDocument(id, params) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(
					`/document/print/${id}${
						params ? `?${new URLSearchParams(params).toString()}` : ''
					}`,
					HEADER
				);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	}
};
